import React, { useState } from "react";
import { Accordion, Card } from 'react-bootstrap';

import Section from './section.js';

const FaqItem = ({ faq, index }) => {

  const { field_question, field_answer } = faq;

  const [ expanded, setExpanded ] = useState(false);

  return (
    <Card className="faq-item">
      <Accordion.Toggle
        as={Card.Header}
        eventKey={ index+1 }
        onClick={ ()=>setExpanded(!expanded) }
        className={(expanded?'faq-question__expanded':'faq-question__collapsed')}
      >
        <div className="faq__question">{ field_question }</div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={ index+1 }>
        <Card.Body>
          <div className="faq__answer" dangerouslySetInnerHTML={{ __html: field_answer }}></div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  )
}

const Faqs = ({ data }) => {

  const {
    field_heading,
    field_desc,
    relationships,
    field_subhead
  } = data

  return (
    <Section name='faqs' heading={field_heading} subhead={field_subhead}>

      {
        !!field_desc &&
        <div className="page__blurb text-left" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>
      }

      {
        !!relationships.field_tiles_ref && relationships.field_tiles_ref.length>0 &&
        <Accordion>
        {
          relationships.field_tiles_ref.map((faq, index) => (
            <FaqItem faq={faq} index={index} key={index} />
          ))
        }
        </Accordion>
      }

    </Section>
  )

}

// export means another page can import it and use it
export default Faqs;
